import { TOSIPTypes } from '../../domain/tos.ip';

export enum EditTypes {
    ChangeType = 0,
    Delete = 1
}

export class EditTOSIPRequest {

    IP: string;
    ChangeToType: TOSIPTypes;
    EditType: EditTypes;

}
